// import allEnums from './allEnums'

export default {
  namespaced: true,
  state: {
    clause: {},
    allEnums: {},
  },
  getters: {
    getAnswer: state => payload => {
      let result = ''
      if (payload.from === null) result = null
      else if (payload.select === null && payload.where === null) result = state.allEnums[payload.from]
      else if (payload.select === null && payload.where !== null) result = state.allEnums[state.clause.from].find(candidator => candidator[payload.where] === payload.is)
      else result = state.allEnums[payload.from].find(candidator => candidator[payload.where] === payload.is)[payload.select]
      return result
    },
  },
  mutations: {
    setItems(state, items) {
      state.allEnums = Object.freeze(items)
      // state.clause = Object.freeze({from:'',select:'',where:'',is:''})
    },
    query(state, payload) {
      state.clause[payload.clause] = payload.value
      state.clause = Object.freeze(state.clause)
    },
  },
  actions: {},
}
